// extracted by mini-css-extract-plugin
module.exports = {"root":"EventDetails__root___1uaTu","content":"EventDetails__content___pey-j","time":"EventDetails__time___29RZ4"};